import type { SVGProps } from 'react';

interface ClimberIconProps extends Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> {
  size?: number | string;
}

export default function ClimberIcon({
  size = 24,
  strokeWidth = 2,
  ...props
}: ClimberIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {/* head */}
      <circle cx="15" cy="4" r="1.8" />
      {/* upper torso */}
      <path d="M15 6c-1.5 2-3 3.5-5 4.5" />
      {/* reaching arm up to a hold */}
      <path d="M15 6l4-2" />
      {/* lower arm grabbing wall */}
      <path d="M13 8l-3 3" />
      {/* hips */}
      <path d="M10 10.5l1 4" />
      {/* bent leg pushed up against the wall */}
      <path d="M11 14.5l4-1l1 4" />
      {/* trailing leg pushing down */}
      <path d="M11 14.5l-3 6" />
    </svg>
  );
}
